import Env from '../base/env';
import { module } from 'modujs';
import Cookies from 'js-cookie';
import gsap from 'gsap';
import Marquee3k from 'marquee3000';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
      close: document.getElementById('close-annoucement'),
    };
    this.VARS = {
      nameCookie: 'announcement_bar_hidden',
    };

    if (this.DOM.view != null) {
      gsap.delayedCall(1, () => {
        this.detect();
        this.launch();
      });
    }
  }

  create() {
    const oneHour = new Date(new Date().getTime() + 60 * 60 * 1000);
    Cookies.set(this.VARS.nameCookie, 1, {
      expires: oneHour,
    });
  }

  detect() {
    if (Cookies.get(this.VARS.nameCookie) == 1) {
      this.DOM.view.classList.add('hide');
    } else {
      this.DOM.view.style.visibility = 'visible';
      Env.$html.classList.add('with-announcement');
    }
  }

  launch() {
    if (Env.mobileCSS) {
      Marquee3k.init({
        selector: 'js-marquee',
      });
    }

    gsap.delayedCall(0.6, () => {
      this.DOM.close.addEventListener('click', () => {
        this.create();
        Env.$html.classList.remove('with-announcement');
        this.DOM.view.classList.add('hide');
        gsap.delayedCall(1, () => {
          this.DOM.view.parentElement.removeChild(this.DOM.view);
        });
      });
    });
  }
}
